import stripCharacters from '../../../../../utils/strip-characters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import {sixDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';
import fieldTypes from '../../../../../../enums/FieldTypes';
import PredictionsByField from '../../PredictionsByField';
import validateAutocompleteField from '../../validateAutocompleteField';

const formatINPostcode = (value) => {
  if (!value) return value;
  return value.replace(/\s/g, '');
};

const county = PredictionsByField.county('IN');

const FieldDefinitionIN = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    maxLength: 6,
    transform: formatINPostcode,
    validate: [required.postCode, max.lengthPostCode(6), sixDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
  },
  companyName,
  streetName,
  addressLine2,
  nameNumber,
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: county,
    validate: [required.county, max.lengthAddress(45), validateAutocompleteField(county, 'county')],
  },
];

export default FieldDefinitionIN;
